import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-627564e1"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 1,
  class: "dev_tools"
};
import { ref } from "vue";
import { useRoute } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'App',

  setup(__props) {
    const ENV = process.env.VUE_APP_ENV;
    const use_server = localStorage.getItem('use_server');
    const api_server = ref(use_server === 'http://localhost:8000');
    const route = useRoute();

    const set_server = val => {
      localStorage.setItem('use_server', val ? 'http://localhost:8000' : 'https://self.unxt.app/test');
    };

    return (_ctx, _cache) => {
      const _component_el_switch = _resolveComponent("el-switch");

      const _component_router_view = _resolveComponent("router-view");

      return _openBlock(), _createElementBlock(_Fragment, null, [_unref(route).name !== 'DocuSignCompleted' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [], 64)) : _createCommentVNode("", true), _unref(ENV) === 'DEV' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_switch, {
        modelValue: api_server.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => api_server.value = $event),
        onChange: set_server,
        class: "mb-2",
        "active-text": "Local",
        "inactive-text": "Testing"
      }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), _createVNode(_component_router_view)], 64);
    };
  }

});